import { Action } from "@ngrx/store";
import { UserLevel, UserLevelRequest } from "@edp-models/user-level.model";
import { TransactionHistory, TransactionHistoryRequest } from "@edp-models/transactions-history.model";

export enum ELevelsActions {
    LoadUserLevel = "[Levels] Loading user level",
    SaveUserLevel = "[Levels] Saving user level",
    GetHistory = "[Levels] Loading history",
    SaveHistory = "[Levels] Saving history",
    SetCelebrationScore = "[Levels] Set Celebration Score",
    SetShowCelebration = "[Levels] Set Show Celebration",
    ResetCelebration = "[Levels] Reset Celebration",
}

export class LoadUserLevel implements Action {
    public readonly type = ELevelsActions.LoadUserLevel;
    constructor(public payload?: UserLevelRequest) {}
}
export class SaveUserLevel implements Action {
    public readonly type = ELevelsActions.SaveUserLevel;
    constructor(public payload: UserLevel) {}
}

export class GetHistory implements Action {
    public readonly type = ELevelsActions.GetHistory;
    constructor(public payload: TransactionHistoryRequest) {}
}
export class SaveHistory implements Action {
    public readonly type = ELevelsActions.SaveHistory;
    constructor(public payload: TransactionHistory) {}
}

export class SetCelebrationScore implements Action {
    public readonly type = ELevelsActions.SetCelebrationScore;
    constructor(public payload: number) {}
}

export class SetShowCelebration implements Action {
    public readonly type = ELevelsActions.SetShowCelebration;
    constructor(public payload: boolean) {}
}

export class ResetCelebration implements Action {
    public readonly type = ELevelsActions.ResetCelebration;
}

export type LevelsActions =
    | LoadUserLevel
    | SaveUserLevel
    | GetHistory
    | SaveHistory
    | SetCelebrationScore
    | SetShowCelebration
    | ResetCelebration;
